import React from 'react';
import { CONTACT_EMAIL } from '../constants/contact';
import { volunteerRoles } from '../constants/programData';

const VolunteerSection = () => {
  return (
    <div id="volunteer" className="glass-section h-full">
      <div className="text-white">
        <h2 className="text-3xl lg:text-4xl font-bold mb-5 drop-shadow-xl text-center font-display">
          Volunteering
        </h2>

        <p className="text-lg sm:text-xl leading-relaxed drop-shadow-lg text-center mb-5">
          <span className="text-green-300 font-semibold" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
            The success of TRNF relies on enthusiastic volunteers!
          </span>
        </p>

        {/* Volunteer Role Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
          {volunteerRoles.map(({ title, description, icon }) => (
            <div key={title} className="bg-white/10 rounded-xl p-4 border border-white/20 text-center">
              <div className="w-10 h-10 mx-auto mb-2 bg-green-300/20 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-green-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {icon}
                </svg>
              </div>
              <h4 className="text-sm font-semibold text-white mb-1">{title}</h4>
              <p className="text-xs text-white/70">{description}</p>
            </div>
          ))}
        </div>

        <p className="text-base sm:text-lg leading-relaxed drop-shadow-lg text-center lg:text-left mb-6 text-white/90">
          All volunteers receive in-service training to better support the special needs of our riders.
        </p>

        <div className="flex justify-center">
          <a
            href={`mailto:${CONTACT_EMAIL}?subject=Volunteer%20Inquiry`}
            className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-full text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center min-h-[48px]"
          >
            Volunteer With Us
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default VolunteerSection;
